module.exports = __webpack_public_path__ + "static/media/error.3992b2cd.svg";